import ImageComponent from "@/common/ImageComponent";
import { useCartContext } from "@/setup/cartProvider";
import { Box, Grid, Text } from "@mantine/core";
import { FiImage } from "@react-icons/all-files/fi/FiImage";
import { useRouter } from "next/router";
import numeral from "numeral";
import useStyles from "../../cart/styles/CartLeftSection";

function ItemCheckOut() {
  const { classes } = useStyles();
  const { info_order } = useCartContext();
  const { locale } = useRouter();
  function Item({ item }) {
    const pictureUrl = item?.exfields_detail?.picture_tt || item?.picture;
    const gia_ban = item?.gia_ban_nt - item?.tien_ck / item.sl_xuat;
    return (
      <Grid key={item?._id} gutter="sm">
        <Grid.Col
          md={6}
          lg={2}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          {pictureUrl ? (
            <ImageComponent src={pictureUrl} width="100%" height="100%" />
          ) : (
            <FiImage size={50} />
          )}
        </Grid.Col>
        <Grid.Col md={6} lg={4}>
          <Grid gutter="xs">
            <Grid.Col>
              <Text className={classes.productName}>
                {item?.ten_vt
                  ? locale === "vi"
                    ? item?.ten_vt
                    : item?.ten_vt_eng
                  : "..."}
              </Text>
            </Grid.Col>
            <Grid.Col>
              {item?.thuoc_tinh && (
                <Text className={classes.propertiesName}>
                  {item?.thuoc_tinh?.gia_tri_bien_the_1},{" "}
                  {item?.thuoc_tinh?.gia_tri_bien_the_2}
                </Text>
              )}
            </Grid.Col>
            {/* <Grid.Col>
              {!item?.ton && (
                <Text className={classes.inStock}>Đang có hàng</Text>
              )}
            </Grid.Col> */}
          </Grid>
        </Grid.Col>
        <Grid.Col md={6} lg={3}>
          {gia_ban !== item?.gia_ban_nt && (
            <Text>{numeral(gia_ban).format("0,0")}</Text>
          )}
          <Text
            sx={{
              fontSize: gia_ban !== item?.gia_ban_nt && 14,
            }}
            strikethrough={gia_ban !== item?.gia_ban_nt && true}
            className={classes.price}
          >
            {numeral(item?.gia_ban_nt).format("0,0")}
          </Text>
        </Grid.Col>
        <Grid.Col md={6} lg={3}>
          <Text className={classes.priceTotal}>
            {numeral(item.tien_nt).format("0,0")}
          </Text>
        </Grid.Col>
      </Grid>
    );
  }

  if (!info_order?._id) {
    return;
  }

  return (
    <Box className={classes.containerMain}>
      {info_order?.details?.map((item) => (
        <Item item={item} key={item?._id} />
      ))}
    </Box>
  );
}

export default ItemCheckOut;
